import * as React from 'react'

import { Tooltip, Avatar, Icon, useTheme } from '@design/pt-ui'
import { CreativeStatus } from '../interfaces/entities/creative'

const statusIcons = {
  work_in_progress: 'schedule',
  archived: 'archive',
  sent_to_agency: 'send',
  specification_finalized: 'check',
  deleted: 'delete',
  outdated: 'timelapse',
}

interface ICreativeStatusIconProps {
  status: CreativeStatus
}

function CreativeStatusIcon(props: ICreativeStatusIconProps) {
  const theme = useTheme()
  const { status } = props

  const statusColorMap: Record<string, string> = {
    work_in_progress: theme.palette.custom.statusIcon.inProgress,
    specification_finalized: theme.palette.custom.statusIcon.finalized,
    sent_to_agency: theme.palette.custom.statusIcon.sent,
    archived: theme.palette.custom.statusIcon.archived,
    outdated: theme.palette.custom.statusIcon.outdated,
  }

  const backgroundColor =
    statusColorMap[status.name] || theme.palette.primary.main

  const icon =
    status.name in statusIcons ? (
      <Icon fontSize="small">
        {statusIcons[status.name as keyof typeof statusIcons]}
      </Icon>
    ) : null

  return (
    <Tooltip title={status.label} placement="top">
      <Avatar
        aria-label="Check"
        sx={{
          width: '25px !important',
          height: '25px !important',
          backgroundColor,
        }}>
        {icon}
      </Avatar>
    </Tooltip>
  )
}

export default CreativeStatusIcon
